/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDimension = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M8.586 2H21a1 1 0 0 1 1 1v12.414l-6.293 6.293A1 1 0 0 1 15 22H3a1 1 0 0 1-1-1V9a1 1 0 0 1 .293-.707zm.828 2-4 4h9.172l4-4zM20 5.414l-4 4v9.172l4-4zM14 20V10H4v10zm-5-9h4v4h-2v-2H9zm-4 4h2v2h2v2H5z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgDimension as Dimension };
